import range from "lodash.range";

export function calcInterest(principal: number, rate: number, time: number) {
  return principal * (1 + rate * time);
}

export const PAYOUT_AGE_LIMIT = 92;

export const calcAge = (a: number, b: number) => {
  return a + b;
};

export type YearlyBreakdown = {
  age: number;
  balance: number;
  interest: number;
  principal: number;
  payout: number;
  gains: number;
}[];

export type AnnuityBreakdown = {
  monthlyPayout: number;
  yearlyBreakdown: YearlyBreakdown;
};

export function calcAnnuityBreakdown(
  interest: number,
  currentAge: number,
  withdrawalAge: number,
  startingPrincipal: number,
  monthlyContribution: number
): AnnuityBreakdown {
  const interestYears = withdrawalAge - currentAge + 1;
  const interestRange = range(interestYears);

  const breakdown: YearlyBreakdown = [];

  let principal = startingPrincipal;
  let gains = 0;

  interestRange.forEach((year, i) => {
    let prevYearBalance = 0;

    if (i === 0) {
      prevYearBalance = startingPrincipal;
      if (monthlyContribution > 0) {
        prevYearBalance += monthlyContribution * 12;
      }
      principal += monthlyContribution * 12;

      const balance = calcInterest(prevYearBalance, interest / 100, 0);
      const interestGains = balance - prevYearBalance;
      gains += interestGains;

      breakdown.push({
        age: currentAge + year,
        balance,
        interest: interestGains,
        principal,
        payout: 0,
        gains: gains,
      });
    } else {
      prevYearBalance = breakdown[i - 1].balance;
      if (monthlyContribution > 0) {
        prevYearBalance += monthlyContribution * 12;
      }
      principal += monthlyContribution * 12;
      const balance = calcInterest(prevYearBalance, interest / 100, 1);
      const interestGains = balance - prevYearBalance;

      gains += interestGains;

      breakdown.push({
        age: currentAge + year,
        balance,
        interest: interestGains,
        principal,
        payout: 0,
        gains,
      });
    }
  });

  const payoutYears = PAYOUT_AGE_LIMIT - withdrawalAge + 1;
  const totalBalance = breakdown[breakdown.length - 1].balance;
  const monthlyPayout = totalBalance / (payoutYears * 12);
  return { monthlyPayout, yearlyBreakdown: breakdown };
}

/**
 * Payout Code to use later.

 // Payout Period
  const payoutYears = PAYOUT_AGE_LIMIT - withdrawalAge + 1;
  const payoutRange = range(payoutYears);

  const totalBalance = breakdown[breakdown.length - 1].balance;

  const monthlyPayout = totalBalance / (payoutYears * 12);

  payoutRange.forEach((year, i) => {
    const age = year + withdrawalAge;
    const prevYearBalance = breakdown[breakdown.length - 1].balance;

    const totalPayout = 12 * monthlyPayout;

    const balance = calcInterest(
      prevYearBalance - totalPayout,
      payoutInterest / 100,
      1
    );

    const interestGains = balance - (prevYearBalance - totalPayout);
    gains += interestGains;

    breakdown.push({
      age,
      balance,
      principal: 0,
      interest: interestGains,
      payout: totalPayout,
      gains,
    });
  });
 */
